import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`fleet_fuel_types\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`name\` text NOT NULL,
	\`name_th\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`fleet_transmissions\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`name\` text NOT NULL,
	\`name_th\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_body_types\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`name\` text NOT NULL,
	\`name_th\` text,
	\`icon\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_brands\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`name\` text NOT NULL,
	\`name_th\` text,
	\`logo_url\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_colors\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`name\` text NOT NULL,
	\`name_th\` text,
	\`hex_code\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_models\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`brand_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`name_th\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`brand_id\`) REFERENCES \`fleet_vehicle_brands\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_sub_models\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`model_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`engine_size\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`model_id\`) REFERENCES \`fleet_vehicle_models\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_generations\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`model_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`year_start\` integer,
	\`year_end\` integer,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`model_id\`) REFERENCES \`fleet_vehicle_models\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_image_types\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`name_en\` text,
	\`media_type\` text DEFAULT 'image' NOT NULL,
	\`is_public\` integer DEFAULT 0 NOT NULL,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_yards\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`branch_id\` text,
	\`code\` text NOT NULL,
	\`name\` text NOT NULL,
	\`name_th\` text,
	\`address\` text,
	\`capacity\` integer,
	\`contact_person\` text,
	\`contact_phone\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`notes\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`branch_id\`) REFERENCES \`core_branches\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicles\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`branch_id\` text,
	\`yard_id\` text,
	\`vehicle_code\` text,
	\`vehicle_name\` text NOT NULL,
	\`license_plate\` text NOT NULL,
	\`license_province\` text,
	\`vin\` text,
	\`engine_number\` text,
	\`brand_id\` text,
	\`model_id\` text,
	\`sub_model_id\` text,
	\`generation_id\` text,
	\`body_type_id\` text,
	\`color_id\` text,
	\`color_name\` text,
	\`year\` integer,
	\`manufacturing_year\` integer,
	\`transmission\` text,
	\`fuel_type\` text,
	\`seats\` integer,
	\`doors\` integer,
	\`mileage\` real DEFAULT 0,
	\`purchase_date\` text,
	\`purchase_price\` real,
	\`current_value\` real,
	\`status\` text DEFAULT 'active' NOT NULL,
	\`ownership_type\` text,
	\`notes\` text,
	\`image_url\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`yard_id\`) REFERENCES \`fleet_vehicle_yards\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`brand_id\`) REFERENCES \`fleet_vehicle_brands\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`model_id\`) REFERENCES \`fleet_vehicle_models\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`sub_model_id\`) REFERENCES \`fleet_vehicle_sub_models\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`generation_id\`) REFERENCES \`fleet_vehicle_generations\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`body_type_id\`) REFERENCES \`fleet_vehicle_body_types\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`color_id\`) REFERENCES \`fleet_vehicle_colors\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`fv_company_status_idx\` ON \`fleet_vehicles\` (\`company_id\`,\`status\`);
CREATE INDEX IF NOT EXISTS \`fv_company_brand_idx\` ON \`fleet_vehicles\` (\`company_id\`,\`brand_id\`);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_documents\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`vehicle_id\` text NOT NULL,
	\`document_type\` text NOT NULL,
	\`document_name\` text NOT NULL,
	\`file_url\` text NOT NULL,
	\`expiry_date\` text,
	\`notes\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`vehicle_id\`) REFERENCES \`fleet_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_images\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`vehicle_id\` text NOT NULL,
	\`image_url\` text NOT NULL,
	\`image_type_id\` text,
	\`caption\` text,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`vehicle_id\`) REFERENCES \`fleet_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_insurance_records\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`vehicle_id\` text NOT NULL,
	\`insurance_type\` text NOT NULL,
	\`provider_name\` text,
	\`policy_number\` text,
	\`coverage_amount\` real,
	\`premium\` real DEFAULT 0,
	\`start_date\` text NOT NULL,
	\`expiry_date\` text NOT NULL,
	\`payment_id\` text,
	\`document_url\` text,
	\`notes\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`vehicle_id\`) REFERENCES \`fleet_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_maintenance_types\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`category\` text,
	\`default_interval_km\` integer,
	\`default_interval_months\` integer,
	\`estimated_cost\` real,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`sort_order\` integer DEFAULT 0 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`fleet_maintenance_records\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`vehicle_id\` text NOT NULL,
	\`maintenance_no\` text NOT NULL,
	\`maintenance_type_id\` text,
	\`service_date\` text NOT NULL,
	\`completion_date\` text,
	\`mileage_at_service\` real,
	\`description\` text,
	\`parts_detail\` text,
	\`labor_cost\` real DEFAULT 0,
	\`parts_cost\` real DEFAULT 0,
	\`total_cost\` real DEFAULT 0,
	\`garage_name\` text,
	\`garage_contact\` text,
	\`invoice_ref\` text,
	\`payment_id\` text,
	\`next_service_km\` real,
	\`next_service_date\` text,
	\`status\` text DEFAULT 'scheduled' NOT NULL,
	\`notes\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`vehicle_id\`) REFERENCES \`fleet_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`maintenance_type_id\`) REFERENCES \`fleet_maintenance_types\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_maintenance_schedules\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`vehicle_id\` text NOT NULL,
	\`maintenance_type_id\` text,
	\`interval_km\` integer,
	\`interval_months\` integer,
	\`last_service_km\` real,
	\`last_service_date\` text,
	\`next_due_km\` real,
	\`next_due_date\` text,
	\`is_active\` integer DEFAULT 1 NOT NULL,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`vehicle_id\`) REFERENCES \`fleet_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`maintenance_type_id\`) REFERENCES \`fleet_maintenance_types\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_registration_records\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`vehicle_id\` text NOT NULL,
	\`registration_date\` text NOT NULL,
	\`expiry_date\` text NOT NULL,
	\`cost\` real DEFAULT 0,
	\`payment_id\` text,
	\`document_url\` text,
	\`notes\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`vehicle_id\`) REFERENCES \`fleet_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_tax_records\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`vehicle_id\` text NOT NULL,
	\`tax_year\` integer NOT NULL,
	\`payment_date\` text NOT NULL,
	\`amount\` real DEFAULT 0,
	\`payment_id\` text,
	\`document_url\` text,
	\`notes\` text,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`vehicle_id\`) REFERENCES \`fleet_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE TABLE IF NOT EXISTS \`fleet_vehicle_transfers\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`transfer_no\` text NOT NULL,
	\`vehicle_id\` text NOT NULL,
	\`from_yard_id\` text,
	\`to_yard_id\` text NOT NULL,
	\`transfer_date\` text NOT NULL,
	\`reason\` text,
	\`mileage_at_transfer\` real,
	\`status\` text DEFAULT 'draft' NOT NULL,
	\`notes\` text,
	\`created_by\` text,
	\`completed_at\` text,
	\`completed_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`vehicle_id\`) REFERENCES \`fleet_vehicles\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`from_yard_id\`) REFERENCES \`fleet_vehicle_yards\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`to_yard_id\`) REFERENCES \`fleet_vehicle_yards\`(\`id\`) ON UPDATE no action ON DELETE no action
);
  `.trim(),
};
